import vuei18n from '@/plugins/vue-i18n'

export const getCoverageTypeName = coverageType => {
  switch (coverageType) {
    case 'HOSPITAL_CARE':
      return vuei18n.t('homeV2.coverage.hospitalization')
    case 'HOSPITALIZATION':
      return vuei18n.t('homeV2.coverage.hospitalization')
    default:
      return ''
  }
}

export const getStatusAuthorizationName = status => {
  switch (status) {
    case 'READY':
      return vuei18n.t('homeV2.status.ready')
    case 'QUALIFICATION':
      return vuei18n.t('homeV2.status.qualification')
    case 'REJECTED':
      return vuei18n.t('homeV2.status.rejected')
    case 'PENDING_REVIEW':
      return vuei18n.t('homeV2.status.pendingReview')
    case 'APPROVED':
      return vuei18n.t('homeV2.status.approved')
    case 'CLAIMED':
      return vuei18n.t('homeV2.status.claimed')
    case 'VOIDED':
      return vuei18n.t('homeV2.status.voided')
    case 'NOT_ATTENDED':
      return vuei18n.t('homeV2.status.notAttended')
    case 'SENT_TO_SPONSOR':
      return vuei18n.t('homeV2.status.sentToSponsor')
    case 'PAYMENT_CONFIRMED':
      return vuei18n.t('homeV2.status.paymentConfirmed')
    case 'PAID':
      return vuei18n.t('homeV2.status.paid')
    default:
      return ''
  }
}

export const getSponsorName = sponsorSlug => {
  switch (sponsorSlug) {
    case 'mx-mutuus':
      return 'Mutuus'
    default:
      return ''
  }
}

export const getStatusNameProductsAuthorization = status => {
  switch (status) {
    case 'APPROVED':
      return vuei18n.t('homeV2.statusProductsAuthorizations.approved')
    case 'REJECTED':
      return vuei18n.t('homeV2.statusProductsAuthorizations.rejected')
    case 'MANUAL_APPROVAL_REQUIRED':
      return vuei18n.t('homeV2.statusProductsAuthorizations.manualReviewRequired')
    default:
      return ''
  }
}
